export const multiSelect = ({ itemToInsertOrRemove, multiSelectItems }) => {
  if (!itemToInsertOrRemove || !multiSelectItems) return [];
  let nextSelectedProducts = [...multiSelectItems];

  if (nextSelectedProducts.includes(itemToInsertOrRemove)) {
    nextSelectedProducts = nextSelectedProducts.filter(
      (f) => f !== itemToInsertOrRemove,
    );
  } else {
    nextSelectedProducts.push(itemToInsertOrRemove);
  }

  return nextSelectedProducts;
};
